import charlidamelio from '../assets/defaultTikTokSecret/charlidamelio.jpeg';
import cznburak from '../assets/defaultTikTokSecret/cznburak.jpeg';
import domelipa from '../assets/defaultTikTokSecret/domelipa.jpeg';
import willsmith from '../assets/defaultTikTokSecret/willsmith.jpeg';
import therock from '../assets/defaultTikTokSecret/therock.jpeg';
import williesalim from '../assets/defaultTikTokSecret/williesalim.jpeg';
import kimberlyloaiza from '../assets/defaultTikTokSecret/kimberlyloaiza.jpeg';
import zachking from '../assets/defaultTikTokSecret/zachking.jpeg';
import addisonre from '../assets/defaultTikTokSecret/addisonre.jpeg';
import bellapoarch from '../assets/defaultTikTokSecret/bellapoarch.jpeg';
import mrbeast from '../assets/defaultTikTokSecret/mrbeast.jpeg';
import khabylame from '../assets/defaultTikTokSecret/khabylame.jpeg';

const tiktokList = [
    {
        username: 'khaby.lame',
        name: 'Khabane lame',
        bio: 'Se vuoi ridere sei nel posto giusto😎 If u wanna laugh u r in the right place😎',
        avatar: khabylame,
        numPosts: 1306,
        following: 84,
        followers: 160500000,
        numAnonMessages: 0,
    },
    {
        username: 'charlidamelio',
        name: 'charli d\'amelio',
        bio: '',
        avatar: charlidamelio,
        numPosts: 2893,
        following: 1290,
        followers: 155900000,
        numAnonMessages: 0,
    },
    {
        username: 'mrbeast',
        name: 'MrBeast',
        bio: 'Beast Games 2: Strong Vs. Smart OUT NOW ON PRIME VIDEO :D',
        avatar: mrbeast,
        numPosts: 438,
        following: 350,
        followers: 124200000,
        numAnonMessages: 0,
    },
    {
        username: 'bellapoarch',
        name: 'Bella Poarch',
        bio: '',
        avatar: bellapoarch,
        numPosts: 797,
        following: 647,
        followers: 92800000,
        numAnonMessages: 0,
    },
    {
        username: 'addisonre',
        name: 'Addison',
        bio: '',
        avatar: addisonre,
        numPosts: 384,
        following: 21,
        followers: 88300000,
        numAnonMessages: 0,
    },
    {
        username: 'zachking',
        name: 'Zach King',
        bio: 'Bringing a little more wonder into the world, 15 seconds at a time',
        avatar: zachking,
        numPosts: 584,
        following: 165,
        followers: 84300000,
        numAnonMessages: 0,
    },
    {
        username: 'kimberly.loaiza',
        name: 'Kimberly Loaiza',
        bio: 'Hola linduras ✨ Únete al grupo 👇🏻',
        avatar: kimberlyloaiza,
        numPosts: 2159,
        following: 409,
        followers: 83700000,
        numAnonMessages: 0,
    },
    {
        username: 'williesalim',
        name: 'WILLIE SALIM',
        bio: 'LINK DONASI',
        avatar: williesalim,
        numPosts: 2897,
        following: 1064,
        followers: 83800000,
        numAnonMessages: 0,
    },
    {
        username: 'therock',
        name: 'The Rock',
        bio: 'CEO of #RockTok\nLife\'s so much sweeter when you\'re not an asshole',
        avatar: therock,
        numPosts: 477,
        following: 0,
        followers: 79900000,
        numAnonMessages: 0,
    },
    {
        username: 'willsmith',
        name: 'Will Smith',
        bio: 'Same kid from West Philly. “Pretty Girls”out now!',
        avatar: willsmith,
        numPosts: 433,
        following: 51,
        followers: 78900000,
        numAnonMessages: 0,
    },
    {
        username: 'domelipa',
        name: 'domelipa',
        bio: '✩Ｅｓｅｎｃｉａ\n📍Mty N.L.',
        avatar: domelipa,
        numPosts: 2538,
        following: 172,
        followers: 76000000,
        numAnonMessages: 0,
    },
    {
        username: 'cznburak',
        name: 'cznburak',
        bio: 'İstanbul/Dubai/Uzbekistan/Medine/China/Bradford/Egypt/Türkmenstan/Jordan/Bahrain',
        avatar: cznburak,
        numPosts: 3056,
        following: 2,
        followers: 74100000,
        numAnonMessages: 0,
    },
];

export {
    tiktokList,
};